import React, { useRef, useState } from "react";

import Modal from "../Modal";
import { sendFeatureFeedback } from "./featureFeedback";

export default function FeatureFeedbackBanner({ extraInfo, featureFeedbackUrl, featureName, targetLanguageName }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hasSent, setHasSent] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState("");
  const [includeAccountDetails, setIncludeAccountDetails] = useState(true);
  const modalRef = useRef(null);

  const send = async () => {
    setIsSending(true);
    try {
      await sendFeatureFeedback({ extraInfo, featureFeedbackUrl, featureName, includeAccountDetails, message, targetLanguageName });
      setHasSent(true);
      modalRef.current?.hide();
    } catch {
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSending(false);
    }
  };

  if (hasSent && !isModalVisible) {
    return <p className="feature-feedback-thanks">Thanks for your feedback!</p>;
  }

  return (
    <>
      <button className="feature-feedback-banner" type="button" onClick={() => setIsModalVisible(true)}>
        <span className="fa fa-comment" /> This feature is new - any feedback?
      </button>
      {isModalVisible && (
        <Modal
          footer={
            <button className="btn btn-success joystix" disabled={!message.trim() || isSending} type="button" onClick={send}>Send</button>
          }
          ref={modalRef}
          title="Feedback"
          onHidden={() => setIsModalVisible(false)}
        >
          <p className="text-muted">Share your thoughts on this feature or general feedback about Clozemaster.</p>
          <textarea
            autoFocus
            className="form-control"
            placeholder="Type your feedback here..."
            rows={4}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />
          <div className="checkbox">
            <label>
              <input checked={includeAccountDetails} type="checkbox" onChange={() => setIncludeAccountDetails(!includeAccountDetails)} />
              Include my account details so we can follow up
            </label>
          </div>
        </Modal>
      )}
    </>
  );
}
